import { UserData } from "types/UserTypes";
import { ApiRoutes } from "./apiRoutes";
import RestService from "./RestService";

export const UserService = {
  getMe: async (): Promise<UserData> => {
    return await RestService.get(ApiRoutes.ME);
  },
};
